import { alphaClient } from '@/services/api-client'

export const getVehiclesInTransit = (
  date: string,
  timeStart: string
): Promise<string[]> =>
  alphaClient
    .get<string[]>(
      `/custom/transdev-lokalbanor/vehicle-in-transit?date=${date}&timeStart=${timeStart}`
    )
    .then((x) => x.data)
